module.exports = __webpack_public_path__ + "img/language-icon.fe881b44.svg";